'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.dispatchAndListen = dispatchAndListen;

var _effects = require('redux-saga/effects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(dispatchAndListen),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(waitForPattern);

function dispatchAndListen(_ref) {
    var action = _ref.action,
        listenTo = _ref.listenTo,
        onTake = _ref.onTake;
    return _regenerator2.default.wrap(function dispatchAndListen$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.fork)(waitForPattern, {
                        patterns: listenTo,
                        callback: onTake
                    });

                case 2:
                    _context.next = 4;
                    return (0, _effects.put)(action);

                case 4:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

function waitForPattern() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { patterns: [], callback: function callback() {} },
        patterns = _ref2.patterns,
        callback = _ref2.callback;

    var result;
    return _regenerator2.default.wrap(function waitForPattern$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.take)(patterns);

                case 2:
                    result = _context2.sent;
                    _context2.next = 5;
                    return (0, _effects.call)(callback, result);

                case 5:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-saga-kit/dist/recipes.js
// module id = 1038
// module chunks = 0